import React from 'react';
import PropTypes from 'prop-types';

/**
 * Single tag component for the input bar
 */
const Tag = ({ tag, index, placeholderInvalid, showLoader, onRemove }) => {
  const tagClasses = [
    'tag',
    tag.class,
    tag.overflow && 'overflow',
    tag.invalid && 'invalid',
    tag.new && 'new',
    tag.waiting && 'waiting',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={tagClasses}>
      <span className="text">{tag.text}</span>

      {tag.display && tag.display.startsWith('@') && !tag.waiting && (
        <span className="mention-wrapper">
          {tag.display.indexOf(' mentions') !== -1 && <span className="term-type">&nbsp;mentions</span>}
          {tag.display.indexOf(' posts') !== -1 && <span className="term-type">&nbsp;posts</span>}
        </span>
      )}

      {tag.invalid && <span className="invalid-message"> ({placeholderInvalid || 'not tracked'})</span>}

      {tag.waiting && showLoader && <span className="loader">...</span>}

      <span
        className="button-remove-tag icon-x-in-circle"
        onClick={(e) => onRemove(index, e)}
        title="Remove interest"
      />
    </div>
  );
};

Tag.propTypes = {
  tag: PropTypes.shape({
    text: PropTypes.string,
    display: PropTypes.string,
    class: PropTypes.string,
    overflow: PropTypes.bool,
    invalid: PropTypes.bool,
    new: PropTypes.bool,
    waiting: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  placeholderInvalid: PropTypes.string,
  showLoader: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
};

export default Tag;
